export default __webpack_public_path__ + "static/wagner-0bde30f4445d23a559e077b66f34380a.jpg";